<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog"  persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>
          {{ text }}
          <div v-for="(item, index) in errors" :key="index">
            {{ item.texto }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="close">OK</v-btn>
          <slot name="button"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ModalAlert',
  props: {
    title: {
      type: String,
      default: 'Alerta!',
    },
    text: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: null,
    },
    maxWidth: {
      type: Number,
      default: 290,
    },
  },
  computed: {
    ...mapState('global', {
      showDialog: state => state.alertModal,
    }),
  },
  methods: {
    close() {
      this.$store.commit('global/closeAlert');
    },
  },
};
</script>
